(function(){
  if (typeof document === 'undefined') return;

  if (('ontouchstart' in window) || navigator.maxTouchPoints > 0) return;

  let shared = null;

  function createSharedMagnifier(size) {
    const container = document.createElement('div');
    container.className = 'magnifier-container';
    container.style.pointerEvents = 'none';

    const mag = document.createElement('div');
    mag.className = 'magnifier';
    mag.style.width = size + 'px';
    mag.style.height = size + 'px';
    mag.style.display = 'none';

    const mimg = document.createElement('img');
    mimg.className = 'magnifier__img';
    mimg.alt = '';
    mimg.style.position = 'absolute';
    mimg.style.display = 'block';
    mimg.style.objectFit = 'contain';
    mimg.style.maxWidth = 'none';
    mimg.style.maxHeight = 'none';

    mag.appendChild(mimg);
    container.appendChild(mag);
    document.body.appendChild(container);

    const overlay = document.createElement('div');
    overlay.className = 'magnifier-overlay';
    document.body.appendChild(overlay);

    return {container, magnifier: mag, mImg: mimg, overlay, size};
  }

  function makeImgMagnifiable(img, size = 450) {
    if (img.dataset.magnifierAttached) return;
    img.dataset.magnifierAttached = '1';

    if (!shared) shared = createSharedMagnifier(size);

    const {container, magnifier, mImg, overlay} = shared;
    
      const getRenderedSrc = () => {
        const src = img.currentSrc || img.src;
        try {
          const url = new URL(src);
          url.searchParams.set('width', '2000');
          return url.toString();
        } catch (e) {
          return src;
        }
      };

    const zoomFactor = (window.MAGNIFIER_ZOOM && parseFloat(window.MAGNIFIER_ZOOM)) || 4;

    const hide = () => { 
      magnifier.style.display = 'none';
      overlay.style.display = 'none';
    };

    const move = (e) => {
      const rect = img.getBoundingClientRect();
      
      const magW = magnifier.clientWidth || shared.size;
      const magH = magnifier.clientHeight || shared.size;
      
      const natW = img.naturalWidth || img.width;
      const natH = img.naturalHeight || img.height;
      const natRatio = natW / natH;
      const containerRatio = rect.width / rect.height;
      
      let actualW, actualH, offsetX, offsetY;
      
      if (natRatio > containerRatio) {
        actualW = rect.width;
        actualH = rect.width / natRatio;
        offsetX = 0;
        offsetY = (rect.height - actualH) / 2;
      } else {
        actualH = rect.height;
        actualW = rect.height * natRatio;
        offsetX = (rect.width - actualW) / 2;
        offsetY = 0;
      }
      
      const mouseX = e.clientX - rect.left - offsetX;
      const mouseY = e.clientY - rect.top - offsetY;
      
      const x = mouseX / actualW;
      const y = mouseY / actualH;
      
    mImg.src = getRenderedSrc();
  mImg.style.width = actualW + 'px';
  mImg.style.height = actualH + 'px';

      const clampedX = Math.max(0, Math.min(1, x));
      const clampedY = Math.max(0, Math.min(1, y));
      
  const centerX = clampedX * actualW;
  const centerY = clampedY * actualH;

  const imgX = -centerX * zoomFactor + (magW / 2);
  const imgY = -centerY * zoomFactor + (magH / 2);

  mImg.style.left = imgX + 'px';
  mImg.style.top = imgY + 'px';
  mImg.style.transform = `scale(${zoomFactor})`;
  mImg.style.transformOrigin = 'top left';

      const spaceRight = window.innerWidth - rect.right;
      
      // Always position to the right of the image.
      // The CSS media query will hide it on smaller screens if it doesn't fit.
      let left = rect.right + 12;
      let top = Math.max(12, Math.min(window.innerHeight - magH - 12, e.clientY - magH / 2));

      container.style.left = left + 'px';
      container.style.top = top + 'px';
      magnifier.style.display = 'block';

  const overlayW = magW / zoomFactor;
  const overlayH = magH / zoomFactor;
      
  const overlayX = rect.left + offsetX + centerX - (overlayW / 2);
  const overlayY = rect.top + offsetY + centerY - (overlayH / 2);

      overlay.style.left = overlayX + 'px';
      overlay.style.top = overlayY + 'px';
      overlay.style.width = overlayW + 'px';
      overlay.style.height = overlayH + 'px';
      overlay.style.display = 'block';
    };

    img.addEventListener('mouseenter', () => {
        mImg.src = getRenderedSrc();
      magnifier.style.display = '';
      overlay.style.display = 'block';
    });
    img.addEventListener('mousemove', move);
    img.addEventListener('mouseleave', hide);
    window.addEventListener('scroll', hide, {passive:true});
    window.addEventListener('resize', hide);
  }

  function init() {
    const selector = '.product-gallery__media img, .product-gallery__media picture img';
    const imgs = document.querySelectorAll(selector);
    imgs.forEach(img => {
      if (img.closest('.product-gallery__thumbnail')) return;
      makeImgMagnifiable(img, 600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else init();

})();
